{
    "NAME": "Lista de usuáriosIdioma",
    "UsersList_Column_FullName": "Nome completo",
    "UsersList_Column_Username": "Nome de usuário",
    "UsersList_Column_LockOut": "Trancado para fora",
    "UsersList_Column_ActivityLastLogon": "Atividade\/Último logon",
    "UsersList_Tooltip_LastLogon_Label": "Último login",
    "UsersList_LastLogon_None": "Sem dados",
    "UsersList_Column_Permissions": "Permissões",
    "UsersList_Column_TelSys": "Servidor de telefonia",
    "UsersList_LockOut_Yes": "Sim",
    "UsersList_LockOut_No": "Não",
    "UsersList_Filter_UserType_Label": "Tipo de usuário",
    "UsersList_UserType_All": "Todos",
    "UsersList_UserType_ServiceWide": "Serviço em geral",
    "UsersList_UserType_SystemWide": "Em todo o sistema",
    "UsersList_UserType_Detached": "Desapegado",
    "UsersList_UserType_AdminInclusive": "Administradores (inclusive)",
    "UsersList_UserType_AdminExclusive": "Administradores (exclusivo)",
    "UsersList_UserType_ReportingHistoricOnly": "Relatórios (apenas históricos)",
    "UsersList_UserType_ReportingBLF": "Relatórios (BLF)",
    "UsersList_UserType_ReportingStd": "Relatórios (padrão)",
    "UsersList_UserType_ReportingACD": "Relatórios (ACD)",
    "UsersList_UserType_ReportingMobileAppAdvanced": "Relatórios (aplicativo móvel avançado)",
    "UsersList_UserType_SignedInNow": "Já iniciei sessão.",
    "UsersList_UserType_SignedInToday": "Fiz login hoje",
    "UsersList_UserType_SignedInThisWeek": "Assinei esta semana",
    "UsersList_UserType_SignedInThisMonth": "Assinado neste mês",
    "UsersList_UserType_SignedInNever": "Nunca entrei em contato.",
    "UsersList_UserType_ActivityToday": "Atividade de hoje",
    "UsersList_UserType_ActivityThisWeek": "Atividades desta semana",
    "UsersList_UserType_ActivityThisMonth": "Atividades deste mês",
    "UsersList_UserType_ActivityNone": "Nenhuma atividade",
    "UsersList_CopyReports_Button": "Copiar relatórios para",
    "UsersList_BulkAdd_Button": "Adição em massa",
    "UsersList_SignInAs_Button": "Entrar como",
    "UsersList_SignInAs_Confirm": "Faça login como **{}**? Você continuará como esse usuário nesta sessão do navegador.",
    "UsersList_CopyReports_Dialog_Title": "Copiar relatórios de **{} ({})**",
    "UsersList_CopyReports_Step_Reports": "Relatórios",
    "UsersList_CopyReports_Step_Targets": "Usuários-alvo",
    "UsersList_CopyReports_Step_Confirm": "Confirmar",
    "UsersList_CopyReports_Intro_Reports": "Selecione um ou mais relatórios para copiar de **{}**.",
    "UsersList_CopyReports_Intro_Targets": "Selecione um ou mais usuários que devem receber cópias desses relatórios.",
    "UsersList_CopyReports_Confirm_Summary": "Você copiará **{}** relatório(s) para **{}** usuário(s).",
    "UsersList_CopyReports_Confirm_Report_Label": "Copiando o relatório **{}**:",
    "UsersList_CopyReports_Confirm_Reports_Label": "Copiando relatórios **{}**:",
    "UsersList_CopyReports_Confirm_Target_Label": "Para o usuário **{}**:",
    "UsersList_CopyReports_Confirm_Targets_Label": "Para **{}** usuários:",
    "UsersList_CopyReports_Overwrite_Label": "Substitua os relatórios existentes sobre os usuários-alvo quando houver conflito de nomes.",
    "UsersList_CopyReports_Success": "Relatórios copiados com sucesso.",
    "UsersList_CopyReports_Cancel": "Cancelar",
    "UsersList_CopyReports_Back": "Voltar",
    "UsersList_CopyReports_Next": "Próximo",
    "UsersList_CopyReports_Copy": "Copiar relatórios",
    "UsersList_CopyReports_Column_Folder": "Pasta",
    "UsersList_CopyReports_Column_ReportName": "Relatório",
    "UsersList_CopyReports_Column_Type": "Tipo",
    "UsersList_CopyReports_Column_Username": "Nome de usuário",
    "UsersList_CopyReports_Column_FullName": "Nome completo",
    "UsersList_CopyReports_Empty_Reports": "Não há relatórios disponíveis para copiar para este usuário.",
    "UsersList_CopyReports_Empty_Targets": "Não há usuários-alvo elegíveis dentro do escopo desta operação de cópia."
}